import { useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import { cleaningForm, createForm, modifyDeleteArr, modifyFilterArr, modifyPushArr, resetMessage, updateForm } from '../../redux/slices/form.js'
import { createMovie, deleteMovieId, updateMovieId } from "../../redux/thunks/movies.js"
import { createSerie, deleteSerieId, updateSerieId } from "../../redux/thunks/series.js"
import { createCarousel, deleteCarouselId, updateCarouselId } from "../../redux/thunks/carousel.js"
import { fetchCategories } from '../../redux/thunks/categories.js'

import DashboardMenu from "../DashboardMenu/DashboardMenu.js"
import Dialog from "../Dialog/Dialog.js"
import DivForm from "../DivForm/DivForm"
import Loading from "../Loading/Loading.js"



const Form = () => {

    const categoriesRedux = useSelector(state => state.categories.data)
    const dispatch = useDispatch()
    const form = useSelector(state => state.form.data)
    const [queryParams] = useSearchParams()
    const message = useSelector(state => state.form.message)
    const navigate = useNavigate()
    const selected = queryParams.get('selected')
    const token = useSelector(state => state.user.token)
    const status = useSelector(state => state.form.status)

    useEffect(() => {
        if (selected) {
            dispatch(createForm(selected))
        }
        return () => {
            dispatch(cleaningForm())
        }
    }, [dispatch, selected, queryParams])

    useEffect(() => {
        if (categoriesRedux.length === 0) {
            dispatch(fetchCategories())
        }
    }, [categoriesRedux, dispatch])

    const handleChange = (e) => {
        let target = e.target.name
        let value = e.target.value
        if (target === "link_trailer") {
            value = value.split('watch?v=').join('embed/')
        }
        if (target !== 'actors' && target !== 'category' && target !== 'type_storage') {
            dispatch(updateForm({ target, value }))
        }
    }

    const handleArr = ({ checkbox, i, input, target }) => {
        if (input !== undefined) {
            //dispatchar accion que pushea string en el array
            dispatch(modifyPushArr({ target, input }))
        } else if (i !== undefined) {
            //dispatcha accion que eliminar elemento clickeado
            dispatch(modifyDeleteArr({ target, i }))
        } else if (checkbox !== undefined) {
            //dispatchar accion
            const opt = Object.keys(checkbox)[0]
            if (checkbox[opt]) {
                dispatch(modifyPushArr({ target, input: opt }))
            } else {
                dispatch(modifyFilterArr({ target, opt }))
            }
        }
    }

    const handleClickUpdate = (e) => {
        const { _id, __v, ...payload } = form
        if (form.movieOrSerie === undefined) {
            !form.season ?
                //movie
                dispatch(updateMovieId({ id: form._id, payload, token })) :
                //serie
                dispatch(updateSerieId({ id: form._id, payload, token }))
        } else {
            //carousel
            dispatch(updateCarouselId({ id: form._id, payload, token }))
        }
    }

    const handleClickDelete = (e) => {
        if (window.confirm(`Estás seguro que querés eliminar ${form.title}?`)) {
            if (form.movieOrSerie !== undefined) {
                //carousel
                dispatch(deleteCarouselId({ id: form._id, token }))
            } else if (!form.season) {
                //movie
                dispatch(deleteMovieId({ id: form._id, token }))
            } else {
                //serie
                dispatch(deleteSerieId({ id: form._id, token }))
            }
        }
    }

    const handleClickCreate = (e) => {
        const { _id, __v, ...payload } = form
        if (form.movieOrSerie === undefined) {
            !form.season ?
                //movie
                dispatch(createMovie({ payload, token })) :
                //serie
                dispatch(createSerie({ payload, token }))
        } else {
            //carousel
            dispatch(createCarousel({ payload, token }))
        }
    }

    return (
        <div className="fl-cl dashboard__container">
            <DashboardMenu />
            <div className="fl-cl form__container">
                {
                    message
                        ? <Dialog dispatcher={resetMessage} id={`dialog`} message={message} navigate={`/dashboard`} />
                        : undefined
                }
                {
                    form._id === undefined
                        ? undefined
                        : <div className="fl-rw form__buttonsOnTop">
                            <button onClick={() => navigate(-1)}>←</button>
                            <button onClick={handleClickDelete}>Eliminar</button>
                        </div>
                }
                {
                    status === 'loading'
                        ? <Loading />
                        : undefined
                }
                {
                    !Object.keys(form).length
                        ? undefined
                        : form.movieOrSerie === undefined
                            ? //PELICULA - SERIE
                            (<div className="form__mainDiv">
                                <DivForm
                                    errorMessage="Debes agregar un titulo"
                                    initialValue={form.title}
                                    label="Título"
                                    name="title"
                                    receiveState={handleChange}
                                    type="text" />
                                {
                                    form.season !== undefined &&
                                    <DivForm
                                        errorMessage=""
                                        initialValue={form.season}
                                        label="Temporada/Season"
                                        name="season"
                                        receiveState={handleChange}
                                        type="number"
                                    />
                                }
                                <DivForm
                                    errorMessage="Debes agregar una descripcion"
                                    initialValue={form.description}
                                    label="Descripción/Sinopsis"
                                    name="description"
                                    receiveState={handleChange}
                                    type="textArea" />
                                <DivForm
                                    errorMessage="Agrega un Director"
                                    initialValue={form.director}
                                    label="Director"
                                    name="director"
                                    receiveState={handleChange}
                                    type="text"
                                />
                                <DivForm
                                    arrayFromData={form.actors}
                                    handleArr={handleArr}
                                    initialValue=""
                                    label="Actores"
                                    name="actors"
                                    type="text"
                                />
                                <DivForm
                                    arrayFromData={form.category}
                                    handleArr={handleArr}
                                    initialValue=""
                                    label="Categorías/Generos"
                                    name="category"
                                    options={categoriesRedux}
                                    type="checkbox"
                                />
                                <DivForm
                                    errorMessage="Agregá el link del banner"
                                    img={form.link_img}
                                    initialValue={form.link_img}
                                    label="Imagen"
                                    name="link_img"
                                    receiveState={handleChange}
                                    type="text"
                                />
                                <DivForm
                                    errorMessage="Agrega otra imagen"
                                    img={form.link_img_larger}
                                    initialValue={form.link_img_larger}
                                    label="Imagen grande"
                                    name="link_img_larger"
                                    receiveState={handleChange}
                                    type="text"
                                />
                                <DivForm
                                    errorMessage="Agregá un trailer... vago"
                                    initialValue={form.link_trailer}
                                    label="Trailer"
                                    name="link_trailer"
                                    receiveState={handleChange}
                                    type="text"
                                />
                                <DivForm
                                    errorMessage="Debes agregar año de lanzamiento"
                                    initialValue={form.release_year}
                                    label="Año de estreno"
                                    name="release_year"
                                    receiveState={handleChange}
                                    type="number"
                                />
                                <DivForm
                                    arrayFromData={form.type_storage}
                                    handleArr={handleArr}
                                    errorMessage="Agregá un tipo de almacenamiento"
                                    initialValue=""
                                    label="Tipo de almacenamiento"
                                    name="type_storage"
                                    type="checkbox"
                                    options={["dvd", "pendrive"]}
                                />
                                {
                                    form._id === undefined
                                        ? <div className="fl-rw form__buttonsOnBottom"><button onClick={handleClickCreate}>Crear</button></div>
                                        : <div className="fl-rw form__buttonsOnBottom">
                                            <button onClick={handleClickUpdate}>Actualizar</button>
                                        </div>
                                }
                            </div>
                            ) : //CAROUSEL
                            (<div className="form__mainDiv">
                                <DivForm
                                    errorMessage="Debes agregar un titulo"
                                    initialValue={form.title}
                                    label="Título"
                                    name="title"
                                    receiveState={handleChange}
                                    type="text" />
                                <DivForm
                                    errorMessage="Agregá en qué seccion verlo"
                                    initialValue={form.movieOrSerie}
                                    label="Se visualiza en page de"
                                    name="movieOrSerie"
                                    placeholder='"serie" o "movie"'
                                    receiveState={handleChange}
                                    type="text"
                                />
                                <DivForm
                                    errorMessage="Agregá el link del banner"
                                    img={form.desktop_img}
                                    initialValue={form.desktop_img}
                                    label="Imagen de escritorio"
                                    name="desktop_img"
                                    receiveState={handleChange}
                                    type="text"
                                />
                                <DivForm
                                    errorMessage="Agregá el link del banner"
                                    img={form.phone_img}
                                    initialValue={form.phone_img}
                                    label="Imagen para smartphone"
                                    name="phone_img"
                                    receiveState={handleChange}
                                    type="text"
                                />
                                <DivForm
                                    errorMessage="Agregá el link del banner"
                                    img={form.tablet_img}
                                    initialValue={form.tablet_img}
                                    label="Imagen para tablet"
                                    name="tablet_img"
                                    receiveState={handleChange}
                                    type="text"
                                />
                                {
                                    form._id === undefined
                                        ? <div className="fl-rw form__buttonsOnBottom"><button onClick={handleClickCreate}>Crear</button></div>
                                        : <div className="fl-rw form__buttonsOnBottom">
                                            <button onClick={handleClickUpdate}>Actualizar</button>
                                        </div>
                                }
                            </div>
                            )}
            </div>
        </div>
    )
}

export default Form